import React from 'react';

const CircleIcon = (props) => {
    const { style, width } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={style} width={width}
             height={'12px'} viewBox="0 0 12 12"><title>Asset 4</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="info">
                    <circle className="cls-1" cx="6" cy="6" r="6"/>
                </g>
            </g>
        </svg>
    )
};

export default CircleIcon;